var exports = {
  "B": "x0a7806d5--cd8d50--flex-row",
};

module.exports = exports;
